export default __webpack_public_path__ + "static/1593-fcef1a6d928e220538b43895338ed6c9.gif";